import GUI from 'lil-gui'

/**
 * CLASS: Debug
 * 
 * @returns debugger - when in url/#debug
 */
export default class Debug {
    constructor()
    {
        // test if #debug is present in URL
        this.active = window.location.hash === '#debug'
        
        if(this.active)
        {
            this.ui = new GUI({ width: 300 })

            window.addEventListener('keydown', (event) => this.onToggleHide(event))
        }
    }

    onToggleHide(event) {
        if(event.key === 'h')
        {
            if(this.ui._hidden)
            {
                this.ui.show()
            }
            else {
                this.ui.hide()
            }
        }
    }
}